import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-xl mx-auto px-6 pt-40 pb-24">
      <XCircle size={44} className="text-destructive" />
      <h1 className="mt-6 font-display text-4xl sm:text-5xl tracking-tight">
        Payment <span className="italic gold-text">cancelled</span>
      </h1>
      <p className="mt-4 text-muted-foreground leading-relaxed">
        No charge was made. Your booking was not completed — the vehicle is still
        available if you'd like to try again or pay via PayPal / Zelle instead.
      </p>
      <Link to="/fleet" className="inline-block mt-8">
        <Button data-testid="payment-cancel-back-button" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-ui">
          Back to Fleet
        </Button>
      </Link>
    </div>
  );
}
